"use strict";

import { setTimeout } from 'timers';
import Vue from 'vue';

var document = window.document, location = window.location;
/**
 * 通用工具
 * 
 * @namespace
 */

/**
 * 用对象路径取一个JSON对象中的子对象引用
 * @param {string} path 对象获取路径
 * @returns {object|string|number|function}
 * @example
 * var aaa = {bbb:123};
 * aaa.objroute('bbb.ccc');
 */
Object.defineProperty(Object.prototype, 'objroute', {
    value: function (path) {
        var obj = this;
        path = String(path);

        var r = /([\d\w_]+)/g, m;

        r.lastIndex = 0;

        while ((m = r.exec(path)) !== null) {
            obj = obj[m[0]];
            if (obj === undefined || obj === null) {
                break;
            }
        }

        return obj;
    },
    writable: false,
    configurable: false,
    enumerable: false
});

var util = {};

/**
 * dom 接口封装
 * 
 * @namespace
 */
util.dom = {
    /**
	 * 获取对象的可视区域宽度
	 *
	 * @param {object} [doc=document] 所需检查的页面document引用
	 * @returns {number}
	 * @example util.dom.getClientWidth(document);
	 */
    getClientWidth: function (doc) {
        var _doc = doc || document;
        return _doc.compatMode == 'CSS1Compat' ? _doc.documentElement.clientWidth : _doc.body.clientWidth;
    },

    /**
	 * 获取对象的可视区域高度
	 *
	 * @param {object} [doc=document] 所需检查的页面document引用
	 * @returns {number}
	 * @example util.dom.getClientHeight(document);
	 */
    getClientHeight: function (doc) {
        var _doc = doc || document;
        return _doc.compatMode == 'CSS1Compat' ? _doc.documentElement.clientHeight : _doc.body.clientHeight;
    },

    /**
	 * 获取对象scrollWidth的值
	 *
	 * @param {object} [doc=document] 所需检查的页面document引用
	 * @returns {number}
	 * @example util.dom.getScrollWidth(document);
	 */
    getScrollWidth: function (doc) {
        var _doc = doc || document;
        return Math.max(_doc.documentElement.scrollWidth, _doc.body.scrollWidth);
    },

    /**
	 * 获取对象scrollHeight的值
	 *
	 * @param {object} [doc=document] 所需检查的页面document引用
	 * @returns {number}
	 * @example util.dom.getScrollHeight(document);
	 */
    getScrollHeight: function (doc) {
        var _doc = doc || document;
        return Math.max(_doc.documentElement.scrollHeight, _doc.body.scrollHeight);
    },

    /**
	 * 获取对象scrollLeft的值
	 *
	 * @param {object} [doc=document] 所需检查的页面document引用
	 * @returns {number}
	 * @example util.dom.getScrollLeft(document);
	 */
    getScrollLeft: function (doc) {
        var _doc = doc || document;
        return (_doc.defaultView && _doc.defaultView.pageXOffset) || Math.max(_doc.documentElement.scrollLeft, _doc.body.scrollLeft);
    },

    /**
	 * 获取对象的scrollTop的值
	 *
	 * @param {object} [doc=document] 所需检查的页面document引用
	 * @returns {number}
	 * @example util.dom.getScrollTop(document);
	 */
    getScrollTop: function (doc) {
        var _doc = doc || document;
        return (_doc.defaultView && _doc.defaultView.pageYOffset) || Math.max(_doc.documentElement.scrollTop, _doc.body.scrollTop);
    }

};

// --------------------------------------------华丽的分割线---------------------------------------------

/**
 * cookie工具
 * 
 * @namespace
 */

util.cookie = {
    /**
	 * 设置一个cookie,还有一点需要注意的，子域可以获取根域下的cookie, 但是根域无法获取子域下的cookie.
	 * @param {String} name cookie名称
	 * @param {String} value cookie值
	 * @param {String} domain 所在域名
	 * @param {String} path 所在路径
	 * @param {Number} hour 存活时间，单位:小时
	 * @return {Boolean} 是否成功
	 * @example
	 *  util.cookie.set('value1','test',"m.nongfadai.com","/h5",24); //设置cookie
	 */
	set : function(name, value, domain, path, hour) {
		if (hour) {
			var expire = new Date();
			expire.setTime(expire.getTime() + 3600000 * hour);
		}
		document.cookie = name + "=" + value + "; " + (hour ? ("expires=" + expire.toGMTString() + "; ") : "") + (path ? ("path=" + path + "; ") : "path=/; ") + (domain ? ("domain=" + domain + ";") : ("domain=" + location.hostname + ";"));
		return true;
	},

    /**
	 * 获取指定名称的cookie值
	 *
	 * @param {String} name cookie名称
	 * @return {String} 获取到的cookie值
	 * @example
	 * 		util.cookie.get('value1'); //获取cookie
	 */
    get: function (name) {
        var r = new RegExp('(?:^|;+|\\s+)' + name + '=([^;]*)'), m = document.cookie.match(r);
        return (!m ? '' : m[1]);
    },

    /**
	 * 删除所有cookie，只能删js写的
	 *
	 * @example
	 * 		util.cookie.clear(); 
	 */
    clear: function () {
        // var cookies = document.cookie.split(";");

        // for (var i = 0; i < cookies.length; i++) {
        //     var cookie = cookies[i];
        //     var eqPos = cookie.indexOf("=");
        //     var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        //     document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        // }

        // var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
        var keys = document.cookie.split('; ').map(function(cookie) { return cookie.split('=')[0]; });
        //console.log(keys);
        if (keys) {
            for (var i = keys.length; i--;) {
                document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();//清除当前域名下的,例如：cyl.noposion.com
                document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString();//清除当前域名下的，例如 .cyl.noposion.com
                document.cookie = keys[i] + '=0;path=/;domain=noposion.com;expires=' + new Date(0).toUTCString();//清除一级域名下的或指定的，例如 .kevis.com
            }
        }
    }
};

// --------------------------------------------华丽的分割线---------------------------------------------

/**
 * 统计
 * 
 * @namespace
 */

util.stat = {

    /**
	* 点击统计
	* 
	* @param {String} [tag = cate.art] 统计标识
	* @param {String} [path = location.pathname] 统计路径
	*/
    click: function (tag, path) {
        if (!tag || !/^\S*nongfadai\.com$/.test(location.host)) {
            return;
        }
        if (typeof (window.__page) == 'string') {
            path = path || window.__page || window.location.pathname;
        } else {
            path = path || window.location.pathname;
        }
        var arr = ['_trackEvent', path], tagarr = tag.split('.');
        for (var i = 0, len = tagarr.length; i < len && i < 3; i++) {
            tagarr[i] && arr.push(tagarr[i]);
        }
        window._hmt && window._hmt.push(arr);
    },

    /**
	* 测速统计
	* 
	* @param {Array} timeStamps 绝对时间点
	* @param {String} [path = location.pathname] 统计路径
	* @value flag1=css加载完成时间
	*        flag2=css到js加载前时间
	*        flag3=js加载完成时间
	*        flag4=js运行完成时间
	*/
    time: function (timeStamps, path) {
        if (!timeStamps || !/^\S*nongfadai\.com$/.test(location.host)) {
            return;
        }
        if (typeof (window.__page) == 'string') {
            path = path || window.__page || window.location.pathname;
        } else {
            path = path || window.location.pathname;
        }
        timeStamps.push(new Date());
        for (var i = 1, len = timeStamps.length; i < len; i++) {
            window._hmt && window._hmt.push(['_trackEvent', path, 'speed', 'flag' + i, timeStamps[i] - timeStamps[0]]);
        }
    },

    /**
	* CGI返回码统计
	* 
	* @param {String} path cgi路径
	* @param {Number} type 成功失败(1=成功,2=失败,3=逻辑失败)
	* @param {Number} code 状态码
	* @param {Number} time 延时单位ms
	*/
    code: function (path, type, code, time) {
        if (!path || !/^\S*nongfadai\.com$/.test(location.host)) {
            return;
        }
        window._hmt && window._hmt.push(['_trackEvent', 'api:' + path, type || 0, code || 0, time || 0]);
    }

};

// --------------------------------------------华丽的分割线---------------------------------------------

/**
 * 计算
 * 
 * @namespace
 */

util.acc = {

    /**
	 * 除法函数
	 * 
	 * @param {Number} arg1 被除数
	 * @param {Number} arg2 除数
	 * @return {Number} arg1除以arg2的精确结果
	 */
    div: function (arg1, arg2) {
        if (!arg1 || !arg2) {
            return arg1 / arg2;
        }
        var t1 = 0, t2 = 0, r1, r2;
        try { t1 = arg1.toString().split('.')[1].length; } catch (e) { /*empty*/0; }
        try { t2 = arg2.toString().split('.')[1].length; } catch (e) { /*empty*/0; }
        r1 = Number(arg1.toString().replace('.', ''));
        r2 = Number(arg2.toString().replace('.', ''));
        return this.mul((r1 / r2), Math.pow(10, t2 - t1));
    },

    /**
	 * 乘法函数
	 * 
	 * @param {Number} arg1 被乘数
	 * @param {Number} arg2 乘数
	 * @return {Number} arg1乘以arg2的精确结果
	 */
    mul: function (arg1, arg2) {
        if (!arg1 || !arg2) {
            return arg1 * arg2;
        }
        var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
        try { m += s1.split('.')[1].length; } catch (e) { /*empty*/0; }
        try { m += s2.split('.')[1].length; } catch (e) { /*empty*/0; }
        return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
    },

    /**
	 * 加法函数
	 * 
	 * @param {Number} arg1 被加数
	 * @param {Number} arg2 加数
	 * @return {Number} arg1加上arg2的精确结果
	 */
    add: function (arg1, arg2) {
        if ((typeof (arg1) != 'number' && typeof (arg1) != 'string') || (typeof (arg2) != 'number' && typeof (arg2) != 'string')) {
            return arg1 + arg2;
        }
        var r1, r2, m;
        try { r1 = arg1.toString().split('.')[1].length; } catch (e) { r1 = 0; }
        try { r2 = arg2.toString().split('.')[1].length; } catch (e) { r2 = 0; }
        m = Math.pow(10, Math.max(r1, r2));
        return (parseInt(this.mul(arg1, m), 10) + parseInt(this.mul(arg2, m), 10)) / m;
    },

    /**
	 * 减法函数
	 * 
	 * @param {Number} arg1 被减数
	 * @param {Number} arg2 减数
	 * @return {Number} arg1减去arg2的精确结果
	 */
    sub: function (arg1, arg2) {
        if (!arg1 || !arg2) {
            return arg1 - arg2;
        }
        var r1, r2, m, n;
        try { r1 = arg1.toString().split('.')[1].length; } catch (e) { r1 = 0; }
        try { r2 = arg2.toString().split('.')[1].length; } catch (e) { r2 = 0; }
        m = Math.pow(10, Math.max(r1, r2));
        n = (r1 >= r2) ? r1 : r2;
        return ((this.mul(arg1, m) - this.mul(arg2, m)) / m).toFixed(n);
    }

};

// --------------------------------------------华丽的分割线---------------------------------------------

/**
 * 获取反跨站请求伪造攻击令牌
 * 
 * @return {Number} 反跨站请求伪造攻击令牌
 */
util.getToken = function (name) {
    var str = this.cookie.get(name || 'token');
    var hash = 5381;
    for (var i = 0, len = str.length; i < len; ++i) {
        hash += (hash << 5) + str.charCodeAt(i);
    }
    return hash & 0x7fffffff;
};

/**
 * 设置header的token
 * 
 * @param {function} func 回调方法
 */
util.setToken = function (func) {
    // window.$jsbridge.post('getToken', null, function(res) {
    //     var _token = res.repair || '';
    //     window.axios.defaults.baseURL = location.protocol + '//' + location.host;
    //     window.$util.cookie.set('token', _token);

    //     func && func();
    // });
    if(navigator.userAgent.indexOf('demeter/') != -1) {//app打开的
        window.$jsbridge.post('getToken', null, function(res) {
            var _headers = window.axios.defaults.headers.common;
            _headers['Authorization'] = res.repair;//token登录态
            localStorage.authorization = res.repair;
            func && func(res);
        });
    } else {//浏览器打开的
        var _headers = window.axios.defaults.headers.common;
        if(sessionStorage.authorization) {
            _headers['Authorization'] = sessionStorage.authorization;
        }
        func && func();
    }
};

/**
 * 设置请求头
 * 
 * @param {function} func 回调方法
 */
util.setHeader = function (func) {
    if(navigator.userAgent.indexOf('demeter/') != -1) {//app打开的
        window.$jsbridge.post('getHeaders', null, function(res) {
            var _headers = window.axios.defaults.headers.common;
            var _repair = res.repair || {};
            _headers['Authorization'] = _repair.Authorization;//token登录态
            _headers['bundleId'] = _repair.bundleId;//包名
            _headers['deviceID'] = _repair.deviceID;//设备id
            _headers['longitude'] = _repair.longitude;//经度
            _headers['latitude'] = _repair.latitude;//纬度
            _headers['loginSource'] = _repair.loginSource;//android,ios
            _headers['sourceVersion'] = _repair.sourceVersion;//机型相关
            //_headers['sign'] = _repair.sign;//防刷
            _headers['useVersion'] = _repair.useVersion;//app版本
            _headers['localChannel'] = _repair.localChannel;//app渠道 农金普惠/农泰

            func && func(res);
        });
    } else {//浏览器打开的
        func && func();
    }
};

/**
 * 追加URL参数
 * 
 * @param {String} url 原URL
 * @param {Object} param 追加参数
 * @param {Boolean} [forHash = false] 是否作为hash追加
 * @return {String} 新URL
 */
util.appendUrlParam = function (url, param, forHash) {
    if (!url) {
        return '';
    }
    if (!param) {
        return url;
    }
    var p = [];
    for (var k in param) {
        p.push(encodeURIComponent(k) + '=' + encodeURIComponent(param[k]));
    }
    p = p.join('&');
    var hash = url.split('#');
    url = hash[0].split('?');
    hash = hash[1] ? ('#' + hash[1]) : '';
    param = url[1] ? ('?' + url[1]) : '';
    url = url[0];
    var v = forHash ? hash : param;
    v = v ? v.lastIndexOf('&') == v.length - 1 ? (v + p) : (v + '&' + p) : ('?' + p);
    if (forHash) {
        hash = v;
    } else {
        param = v;
    }
    return url + param + hash;
};

/**
 * 获取url query参数或hash参数
 * 
 * @param {String} name 参数名
 * @param {String} url 参数名
 * @return {String} 参数值
 */
util.getUrlParam = function (name, url) {
    var re = new RegExp('(?:\\?|#|&)' + name + '=([^&#?]*)(?:\\?|$|&|#)', 'i');
    var m = re.exec(url || window.location.href);
    return m ? m[1] : '';
};

/**
 * 千分位格式
 * 
 * @param {Number|String} num 参数名
 * @return {String} 千分位格式的数字
 */
util.toThousands = function (num) {
    if (typeof (num) != 'number' && typeof (num) != 'string') {
        return num;
    }
    var re = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g;
    if (num.toString().indexOf('.') != -1) { //不对小数点后的数进行千分位格式化
        var numArray = num.toString().split('.');
        return numArray[0].toString().replace(re, '$1,') + '.' + numArray[1];
    }
    return num.toString().replace(re, '$1,');
};

util.toThousands00 = function (num) {
    if (typeof (num) != 'number' && typeof (num) != 'string') {
        return num;
    }
    var n = parseFloat(num).toFixed(2);
    var re = /(\d{1,3})(?=(\d{3})+(?:\.))/g;
    var str = n.replace(re, '$1,');
    return str;
};
/**
 * 获取字串的长度,中文算两个字节
 * 
 * @param {String} str 参数名
 * @return {Number} 字符串长度
 */
util.getStrLength = function (str) {
    str = str || '';
    str = str.toString();
    var oLength = str.length;
    var l = 0;
    for (var i = 0; i < oLength; i++) {
        if (str.substring(i, i + 1).match(/[\u4e00-\u9fa5]/)) {
            l += 2;
        } else {
            l += 1;
        }
    }
    return l;
};

/**
 * 保留两位小数 浮点数四舍五入 位数不够 不补0
 * 
 * @param {String} src 浮点数
 * @param {String} pos 小数位数
 * @return {String} 数值
 */
util.fomatFloat = function(src, pos) {
    if (typeof (pos) != 'number') {
        pos = 2;
    }
    return Math.round(src * Math.pow(10, pos)) / Math.pow(10, pos);
};

/**
 * 银行卡号格式化
 * 
 * @param {String} num 参数名
 * @return {String} 每隔四位加入一个空格
 */
util.formatCTNum = function (num) {
    return num.replace(/[^0-9]/g, '').replace(/(\d{4})(?!$)/g, '$1 ');
};

/**
 *  说明：过滤XSS
 *  @return {String} 生成的内容
 */
util.xss = function (val) {
    if (typeof (val) == 'number') {
        return val;
    } else {
        val = val || '';
        return val.toString().replace(/&(?!w+;)/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\n/g, '<br />');
    }
};

/**
 *  说明：时间转换，将秒转换为X天X小时X分X秒
 *  p_nSecondTime：需要转换的以秒为单位的数据
 *  @return {String} 生成的内容
 */
util.convertSecToDay = function (p_nSecondTime) {
    var time = parseInt(p_nSecondTime) + '秒';
    if (parseInt(p_nSecondTime, 10) >= 60) {
        var second = parseInt(p_nSecondTime, 10) % 60;
        var min = parseInt(p_nSecondTime / 60, 10);
        time = min + '分' + second + '秒';
        if (min >= 60) {
            min = parseInt(p_nSecondTime / 60, 10) % 60;
            var hour = parseInt(parseInt(p_nSecondTime / 60, 10) / 60);
            time = hour + '小时' + min + '分' + second + '秒';
            if (hour >= 24) {
                hour = parseInt(parseInt(p_nSecondTime / 60, 10) / 60, 10) % 24;
                var day = parseInt(parseInt(parseInt(p_nSecondTime / 60, 10) / 60, 10) / 24, 10);
                time = day + '天' + hour + '小时' + min + '分' + second + '秒';
            }
        }
    }
    return time;
};

/**
 * 日期格式化
 * 
 * @param {Number/String} time 时间戳或时间字符串
 * @param {String} fmt 格式模型
 * @param {boolean} forEng 中/英文模式
 * @return {String} 格式化的日期
 */
util.formatDate = function (time, fmt, forEng) {
    if (!time) {
        return time;
    }
    /*if(typeof(time) == 'string') {
		time = time.substr(0, 10).replace(/\D/g, '/') + ' ' + (time.substr(11).replace(/\D/g, ':') || '00:00:00');
	}*/
    time = new Date(time);
    /**
	 * @function 取数字子串
	 * @param {Any} s 待取内容，将转换为字符串形式
	 * @param {Number} n 预期数字字符个数
	 * @param {Number} m 用于规范n的最多个数，0不限制
	 * @param {Number} [o=0] &1-是(1)否(0)补0 &2-是(1)否(0)强制截断数字 &4-在数字前(0)或后(1)补足前后导0(如果设置为补0) - 或 - 截断前(0)或后(1)面的数字(如果设置为强制截断) &8-是(1)否(0)删除前后导0
	 */
    var ss = function (s, n, m, o) {
        s = (s + '').split('');
        m && (n = Math.min(n, m));
        o = o || 0;
        var l = s.length;
        if (o & 1) {
            for (var i = l; i < n; i++) {
                (o & 4) ? s.push(0) : s.unshift(0);
            }
        }
        if (n < l && (o & 2)) {
            if (o & 4) {
                s = s.slice(0, n);
            } else {
                s = s.slice(l - n, l);
            }
        }
        s = s.join('');
        (o & 8) && (s = s.replace(/^0*(.+?)0*$/, '$1'));
        return s;
    };
    return fmt.replace(/(y|M|d|h|H|m|s|f|F|t)+/g, function (match) {
        var c = match.charAt(0), l = match.length;
        switch (c) {
            case 'y':
                return ss(time.getFullYear(), l, 4, 2);
            case 'M':
                if (l <= 2) {
                    return ss(time.getMonth() + 1, l, 2, 1);
                }
                return (forEng ? (l == 3 ? ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']) : ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'])[time.getMonth()];
            case 'd':
                if (l <= 2) {
                    return ss(time.getDate(), l, 2, 1);
                }
                return (forEng ? (l == 3 ? ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thurday ', 'Friday', 'Saturday']) : ['周日', '周一', '周二', '周三', '周四', '周五', '周六'])[time.getDay()];
            case 'h':
                return ss((time.getHours() % 12) || 12, l, 2, 1);
            case 'H':
                return ss(time.getHours(), l, 2, 1);
            case 'm':
                return ss(time.getMinutes(), l, 2, 1);
            case 's':
                return ss(time.getSeconds(), l, 2, 1);
            case 'f':
                return ss(time.getMilliseconds(), l, 0, 7);
            case 'F':
                return ss(time.getMilliseconds(), l, 0, 14);
            case 't':
                return ss(time.getHours() >= 12 ? (forEng ? 'PM' : '下午') : (forEng ? 'AM' : '上午'), l, 2, 6);
            default:
                return match;
        }
    });
};

/**
 * 日期格式化
 * 
 * @param {Number/String} date1 时间戳或时间字符串
 * @param {Number/String} date2 时间戳或时间字符串
 * @return {String} 类型 days years
 */
util.timeDiff=function (date1, date2,type) {
    // 将日期字符串转换为Date对象
    var d1 = new Date(date1);
    var d2 = new Date(date2);
    
    // 计算两个日期的时间差（毫秒）
    var timeDiff = Math.abs(d2.getTime() - d1.getTime());
    
    switch (type) {
        case 'days':
            // 计算天数
            var days = Math.ceil(timeDiff / (1000 * 3600 * 24));
            return days;
        case 'years':
            // 计算年数
            var years = Math.floor(timeDiff / (1000 * 3600 * 24 * 365));
            return years;
        default:
            break;
    }
}
/**
 * 金额格式化
 * 
 * @param {Number/String} Num 金额字符串
 * @return {String} 格式化的金额
 */
util.Arabia2Chinese = function (Num) {
    Num = Num || '0';
    Num = Num.toString();
    if (Number(Num) == 0) {
        return '';
    }
    for (var i = Num.length - 1; i >= 0; i--) {
        Num = Num.replace(',', '');
        Num = Num.replace(' ', '');
    }
    Num = Num.replace('￥', '');
    if (isNaN(Num)) {
        return '请检查小写金额是否正确';
    }
    var part = String(Num).split('.');
    var newchar = '';
    for (i = part[0].length - 1; i >= 0; i--) {
        if (part[0].length > 10) {
            return '位数过大，无法计算';
        }
        var tmpnewchar = '';
        var perchar = part[0].charAt(i);
        switch (perchar) {
            case '0': tmpnewchar = '零' + tmpnewchar; break;
            case '1': tmpnewchar = '壹' + tmpnewchar; break;
            case '2': tmpnewchar = '贰' + tmpnewchar; break;
            case '3': tmpnewchar = '叁' + tmpnewchar; break;
            case '4': tmpnewchar = '肆' + tmpnewchar; break;
            case '5': tmpnewchar = '伍' + tmpnewchar; break;
            case '6': tmpnewchar = '陆' + tmpnewchar; break;
            case '7': tmpnewchar = '柒' + tmpnewchar; break;
            case '8': tmpnewchar = '捌' + tmpnewchar; break;
            case '9': tmpnewchar = '玖' + tmpnewchar; break;
        }
        switch (part[0].length - i - 1) {
            case 0: tmpnewchar = tmpnewchar + '元'; break;
            case 1: if (perchar != 0) tmpnewchar = tmpnewchar + '拾'; break;
            case 2: if (perchar != 0) tmpnewchar = tmpnewchar + '佰'; break;
            case 3: if (perchar != 0) tmpnewchar = tmpnewchar + '仟'; break;
            case 4: tmpnewchar = tmpnewchar + '万'; break;
            case 5: if (perchar != 0) tmpnewchar = tmpnewchar + '拾'; break;
            case 6: if (perchar != 0) tmpnewchar = tmpnewchar + '佰'; break;
            case 7: if (perchar != 0) tmpnewchar = tmpnewchar + '仟'; break;
            case 8: tmpnewchar = tmpnewchar + '亿'; break;
            case 9: tmpnewchar = tmpnewchar + '拾'; break;
        }
        newchar = tmpnewchar + newchar;
    }
    if (Num.indexOf('.') != -1) {
        if (part[1].length > 2) {
            part[1] = part[1].substr(0, 2);
        }
        for (i = 0; i < part[1].length; i++) {
            tmpnewchar = '';
            perchar = part[1].charAt(i);
            switch (perchar) {
                case '0': tmpnewchar = '零' + tmpnewchar; break;
                case '1': tmpnewchar = '壹' + tmpnewchar; break;
                case '2': tmpnewchar = '贰' + tmpnewchar; break;
                case '3': tmpnewchar = '叁' + tmpnewchar; break;
                case '4': tmpnewchar = '肆' + tmpnewchar; break;
                case '5': tmpnewchar = '伍' + tmpnewchar; break;
                case '6': tmpnewchar = '陆' + tmpnewchar; break;
                case '7': tmpnewchar = '柒' + tmpnewchar; break;
                case '8': tmpnewchar = '捌' + tmpnewchar; break;
                case '9': tmpnewchar = '玖' + tmpnewchar; break;
            }
            if (i == 0) tmpnewchar = tmpnewchar + '角';
            if (i == 1) tmpnewchar = tmpnewchar + '分';
            newchar = newchar + tmpnewchar;
        }
    }
    while (newchar.search('零零') != -1)
        newchar = newchar.replace('零零', '零');
    newchar = newchar.replace('零亿', '亿');
    newchar = newchar.replace('亿万', '亿');
    newchar = newchar.replace('零万', '万');
    newchar = newchar.replace('零元', '元');
    newchar = newchar.replace('零角', '');
    newchar = newchar.replace('零分', '');
    if (newchar.charAt(newchar.length - 1) == '元' || newchar.charAt(newchar.length - 1) == '角')
        newchar = newchar + '整';
    return newchar;
};

/**
 * 获取客户端类型
 */
util.getClientType = function () {
    let client = '';
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {  //判断iPhone|iPad|iPod|iOS
      client = 'iOS';
    } else {
      client = 'Android';
    }
    return client;
};
/**
 * 判断是否是移动设备
*/
util.isMobile = function() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);	
}

/**
 * 是否是微信客户端
 */
util.isWeChat = function() {
    return /micromessenger/i.test(navigator.userAgent);
};

/**
 * 是否是企业微信客户端
 */
 util.isWeWork = function() {
    return /wxwork/i.test(navigator.userAgent)&&!(/windows/i.test(navigator.userAgent));
};
/**
 * 是否是QQ客户端
 */
util.isQQ = function() {
    return /\s+QQ/.test(navigator.userAgent);
};

/**
 * 设置setBack 上一个页面为h5页面,而不是直接回到app
 */
util.setBackWebView = function() {
    Vue.$jsbridge.post('setBack', {backToWebview: true}, null);
};

/**
 * 打开第三方APP
 */
util.openApp = function(bankCode, bankName) {
    if(!bankCode) {
        return;
    }
    var urlMap = {
        Android: {
            ABOC: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.android.bankabc',//农业银行
            ICBK: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.icbc',//工商银行
            PCBC: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.chinamworld.main',//建设银行
            BKCH: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.chinamworld.bocmbci',//中国银行
            CMBC: 'http://a.app.qq.com/o/simple.jsp?pkgname=cmb.pb',//招商银行
            PSBC: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.yitong.mbank.psbc',//邮储银行
            EVER: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.cebbank.mobile.cemb',//光大银行
            FJIB: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.cib.cibmb',//兴业银行
            CIBK: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ecitic.bank.mobile',//中信银行
            BOSH: 'http://a.app.qq.com/o/simple.jsp?pkgname=cn.com.shbank.mper',//上海银行
            GDBK: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.cgbchina.xpt',//广发银行
            HXBK: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.rytong.app.bankhx',//华夏银行
            BJCN: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.rytong.bankbj',//北京银行
            SZDB: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.pingan.paces.ccms',//平安银行
            COMM: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.bankcomm.Bankcomm',//交通银行
            SPDB: 'http://a.app.qq.com/o/simple.jsp?pkgname=cn.com.spdb.mobilebank.per',//浦发银行
            MSBC: 'http://a.app.qq.com/o/simple.jsp?pkgname=cn.com.cmbc.newmbank'//民生银行
        },
        iOS: {
            ABOC: 'https://itunes.apple.com/cn/app/%E5%86%9C%E8%A1%8C%E6%8E%8C%E4%B8%8A%E9%93%B6%E8%A1%8C/id515651240?mt=8',
            ICBK: 'https://itunes.apple.com/cn/app/%E4%B8%AD%E5%9B%BD%E5%B7%A5%E5%95%86%E9%93%B6%E8%A1%8C/id423514795?mt=8',
            PCBC: 'https://itunes.apple.com/cn/app/%E4%B8%AD%E5%9B%BD%E5%BB%BA%E8%AE%BE%E9%93%B6%E8%A1%8C/id391965015?mt=8',
            BKCH: 'https://itunes.apple.com/cn/app/%E4%B8%AD%E5%9B%BD%E9%93%B6%E8%A1%8C%E6%89%8B%E6%9C%BA%E9%93%B6%E8%A1%8C/id399608199?mt=8',
            CMBC: 'https://itunes.apple.com/cn/app/%E6%8B%9B%E5%95%86%E9%93%B6%E8%A1%8C/id392899425?mt=8',
            PSBC: 'https://itunes.apple.com/cn/app/%E9%82%AE%E5%82%A8%E6%89%8B%E6%9C%BA%E9%93%B6%E8%A1%8C/id493489515?mt=8',
            EVER: 'https://itunes.apple.com/cn/app/%E5%85%89%E5%A4%A7%E9%93%B6%E8%A1%8C%E6%89%8B%E6%9C%BA%E9%93%B6%E8%A1%8C/id447733826?mt=8',
            FJIB: 'https://itunes.apple.com/cn/app/%E5%85%B4%E4%B8%9A%E9%93%B6%E8%A1%8C%E6%89%8B%E6%9C%BA%E9%93%B6%E8%A1%8C/id433592972?mt=8',
            CIBK: 'https://itunes.apple.com/cn/app/%E4%B8%AD%E4%BF%A1%E9%93%B6%E8%A1%8C%E6%89%8B%E6%9C%BA%E9%93%B6%E8%A1%8C/id422844108?mt=8',
            BOSH: 'https://itunes.apple.com/cn/app/%E4%B8%8A%E6%B5%B7%E9%93%B6%E8%A1%8C%E6%89%8B%E6%9C%BA%E9%93%B6%E8%A1%8C/id631875777?mt=8',
            GDBK: 'https://itunes.apple.com/cn/app/%E5%B9%BF%E5%8F%91%E9%93%B6%E8%A1%8C%E6%89%8B%E6%9C%BA%E9%93%B6%E8%A1%8C/id415872960?mt=8',
            HXBK: 'https://itunes.apple.com/cn/app/%E5%8D%8E%E5%A4%8F%E9%93%B6%E8%A1%8C%E6%89%8B%E6%9C%BA%E9%93%B6%E8%A1%8C/id666188756?mt=8',
            BJCN: 'https://itunes.apple.com/cn/app/%E4%BA%AC%E5%BD%A9%E7%94%9F%E6%B4%BB-%E5%8C%97%E4%BA%AC%E9%93%B6%E8%A1%8C%E6%89%8B%E6%9C%BA%E9%93%B6%E8%A1%8C%E5%AE%A2%E6%88%B7%E7%AB%AF/id434831001?mt=8',
            SZDB: 'https://itunes.apple.com/cn/app/%E5%B9%B3%E5%AE%89%E5%8F%A3%E8%A2%8B%E9%93%B6%E8%A1%8C-%E4%BF%A1%E7%94%A8%E5%8D%A1%E8%B4%B7%E6%AC%BE%E4%B8%8E%E7%90%86%E8%B4%A2%E6%8A%95%E8%B5%84%E7%9A%84%E9%87%91%E8%9E%8D%E5%B9%B3%E5%8F%B0/id1085016815?mt=8',
            COMM: 'https://itunes.apple.com/cn/app/%E4%BA%A4%E9%80%9A%E9%93%B6%E8%A1%8C/id337876534?mt=8',
            SPDB: 'https://itunes.apple.com/cn/app/%E6%B5%A6%E5%8F%91%E6%89%8B%E6%9C%BA%E9%93%B6%E8%A1%8C/id471855847?mt=8',
            MSBC: 'https://itunes.apple.com/cn/app/%E6%B0%91%E7%94%9F%E9%93%B6%E8%A1%8C%E6%89%8B%E6%9C%BA%E9%93%B6%E8%A1%8C/id523091708?mt=8'
        }
    };
    var clientype = this.getClientType();
    var url = urlMap[clientype][bankCode];
    if(!url) {
        Vue.$message.success({message: '请下载并打开'+(bankName||'')+'银行APP', position: 'center'});
    } else {
        Vue.$jsbridge.post('openApp', {url: url}, null);
    }
};

/**
 * 微信jsapi授权
 */
util.wechatJsApinit = function(jsapi, callback) {
    if(this.isWeChat()) {
        wx.ready(function() {
            //判断当前客户端版本是否支持指定JS接口
            wx.checkJsApi({
                jsApiList: jsapi, // 需要检测的JS接口列表
                success: function(res) {
                    callback && callback(res);
                },
                fail: function(res) {
                    Vue.$message.error({
                        message: res.errMsg,
                        showClose: true
                    });
                }
            });
        });
        wx.error(function(res) {
            Vue.$message.error({
                message: res.errMsg,
                showClose: true
            });
        });
        Vue.axios.post('/app/banner/share/info', {'requestUrl': encodeURIComponent(location.href)}).then(function(json) {
            if(json.statusCode == '0') {
                let wxdata = json.data || {};
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: wxdata.appId, // 必填，公众号的唯一标识
                    timestamp: wxdata.timestamp, // 必填，生成签名的时间戳
                    nonceStr: wxdata.nonceStr, // 必填，生成签名的随机串
                    signature: wxdata.signature, // 必填，签名，见附录1
                    jsApiList: jsapi // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                });
            }
        });
    }
};

/**
 * 获取app渠道
 * 
 * @param {object} self 回调方法
 */
util.getLocalChannel = function (self) {
    if(navigator.userAgent.indexOf('demeter/') != -1) {//app打开的
        window.$jsbridge.post('localChannel', null, function(res) {
            self.localChannel = res.repair || 'nongjinquan';
        });
        //取不到的情况
        setTimeout(function() {
            if(!self.localChannel) {
                self.localChannel = 'nongjinquan';
            }
        }, 500);
    } else {
        //取参数
        let localChannel = self.$route.query.localChannel;
        //去缓存
        if(!localChannel) {
            localChannel = sessionStorage.localChannel || 'nongjinquan';
        }
        self.localChannel = localChannel;
        sessionStorage.localChannel = localChannel;
    }
};


/**
 * 深拷贝函数，支持多种数据类型（如数组、对象、日期、正则表达式、Set、Map等）。
 * 通过递归实现深拷贝，并使用 WeakMap 处理循环引用问题。
 *
 * @param {any} target - 需要深拷贝的目标对象或值。
 * @param {WeakMap} hash - 用于存储已拷贝对象的映射表，防止循环引用，默认为新的 WeakMap 实例。
 * @returns {any} 返回深拷贝后的对象或值。对于基本类型和 null，直接返回原值；对于复杂类型，返回深拷贝结果。
 */
util.cloneDeep = function (target, hash = new WeakMap()) {
  // 处理基本类型和null
  if (target === null || typeof target !== 'object') {
    return target;
  }

  // 处理循环引用
  if (hash.has(target)) {
    return hash.get(target);
  }

  const type = Object.prototype.toString.call(target);
  let cloned;

  switch (type) {
    case '[object Array]':
      cloned = [];
      hash.set(target, cloned);
      for (let i = 0; i < target.length; i++) {
        cloned[i] = util.cloneDeep(target[i], hash);
      }
      break;

    case '[object Object]':
      cloned = Object.create(Object.getPrototypeOf(target));
      hash.set(target, cloned);
      // 处理字符串键
      for (const key in target) {
        if (target.hasOwnProperty(key)) {
          cloned[key] = util.cloneDeep(target[key], hash);
        }
      }
      // 处理Symbol键
      var symbolKeys = Object.getOwnPropertySymbols(target);
      for (const symKey of symbolKeys) {
        cloned[symKey] = util.cloneDeep(target[symKey], hash);
      }
      break;

    case '[object Date]':
      cloned = new Date(target.getTime());
      hash.set(target, cloned);
      break;

    case '[object RegExp]':
      cloned = new RegExp(target.source, target.flags);
      cloned.lastIndex = target.lastIndex; // 复制lastIndex状态
      hash.set(target, cloned);
      break;

    case '[object Set]':
      cloned = new Set();
      hash.set(target, cloned);
      target.forEach(value => {
        cloned.add(util.cloneDeep(value, hash));
      });
      break;

    case '[object Map]':
      cloned = new Map();
      hash.set(target, cloned);
      target.forEach((value, key) => {
        const clonedKey = util.cloneDeep(key, hash);
        const clonedValue = util.cloneDeep(value, hash);
        cloned.set(clonedKey, clonedValue);
      });
      break;

    // 处理其他内置对象，如ArrayBuffer、TypedArray等（示例）
    case '[object ArrayBuffer]':
      cloned = target.slice(0);
      hash.set(target, cloned);
      break;

    case '[object Int8Array]':
    case '[object Uint8Array]':
    case '[object Uint8ClampedArray]':
    case '[object Int16Array]':
    case '[object Uint16Array]':
    case '[object Int32Array]':
    case '[object Uint32Array]':
    case '[object Float32Array]':
    case '[object Float64Array]':
      cloned = new target.constructor(
        util.cloneDeep(target.buffer, hash),
        target.byteOffset,
        target.length
      );
      hash.set(target, cloned);
      break;

    // 默认处理其他对象类型（如函数、其他未处理的内置对象）
    default:
      cloned = target; // 直接返回，不进行深拷贝
      break;
  }

  return cloned;
}

/**
 * 数值四舍五入并保留指定位小数
 * @param {number|string|null} value - 需要处理的数值（支持数字/数字字符串）
 * @param {number} [precision=1] - 要保留的小数位数，默认为1位 如果格式化出来为0则自动增加小数位数
 * @returns {number|null} 处理后的数值，无效输入时返回原值
 */
util.roundToOneDecimal = function(value, precision = 1) {
  if (value === null || value === '' || isNaN(Number(value))) {
    return value; // 如果输入无效，直接返回原值
  }

  const num = Number(value);

  // 判断是否为整数
  if (Number.isInteger(num)) {
    return num; // 如果是整数，直接返回
  }

  const factor = Math.pow(10, precision); // 计算精度因子

  // 手动实现四舍五入逻辑
  let result = Math.round(num * factor) / factor;

  // 如果结果为0，尝试增加小数位数以显示更精确的值
  if (result === 0) {
    let currentPrecision = precision;
    while (result === 0 && currentPrecision <= 6) { // 最大尝试到6位小数
      currentPrecision++;
      const currentFactor = Math.pow(10, currentPrecision);
      result = Math.round(num * currentFactor) / currentFactor;
    }
  }

  // 确保返回值的小数位数与当前精度一致
  return result;
};

const Plugin = {
    install: function (Vue) {
        Vue.$util = util;
        window.$util = util;
        Object.defineProperty(Vue.prototype, '$util', {
            value: util
        });
    }
};



Vue.use(Plugin);

export default util;